import type * as DevToolsPanelAPI from '../../Pages/devtools/api';
import { DevToolsPanelAPICommandName, DevToolsPanelAPIRequestMessage, GetAndSaveHARDevToolsApiRequestMessage } from '../../constants';
import { ProcessInfo } from '../../State/ProcessInfo';
import { SerializableError } from '../utils/SerializedException';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AwaitedReturnType<T extends (args: any) => any> = ReturnType<T> extends PromiseLike<infer U> ?
	U : ReturnType<T>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sendMessage = async <F  extends (args: any) => any>(message: DevToolsPanelAPIRequestMessage) => {
	let result: unknown;
	try {
		result = await chrome.runtime.sendMessage(message);
	} catch (e) {
		ProcessInfo.errorLog(`DevTools Panel API client error sending message`, e);
		throw e;
	}
	if (typeof result === "object" && result != null && "exception" in result) {
		throw SerializableError.from(result.exception, {api: `DevTools Panel API Client`, message});
	} else {
		return result as AwaitedReturnType<F>;
	}
}

export const getAndSaveHAR = (argsObj: Omit<GetAndSaveHARDevToolsApiRequestMessage, "messageType">) =>
	sendMessage<typeof DevToolsPanelAPI.getAndSaveHAR>({
		messageType: DevToolsPanelAPICommandName.getAndSaveHAR, ...argsObj
	});

export const DevToolsPanelAPIClient = {
	getAndSaveHAR
} as const;